import React from "react";

const Footer = () => {
  return (
    <footer className="footer">
      <div className="container-fluid d-flex justify-content-between">
        <nav className="pull-left">
          <ul className="nav">
            <li className="nav-item">
              <a className="nav-link" href="#">
                Help
              </a>
            </li>
            <li className="nav-item">
              <a className="nav-link" href="#">
                Licenses
              </a>
            </li>
          </ul>
        </nav>
        <div className="copyright">
          © Copyright 2025. Savvy Brands, LLC. All Rights Reserved
        </div>
        <div>
        Made with ❤️ in Kansas City.
        </div>
      </div>
    </footer>
  );
};

export default Footer;
